import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoiceLineItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    CustomerTooltipContent,
    CustomerTooltipField,
} from "../../CustomerTooltipContent";
import styles from "./CustomerCell.module.scss";

export const CustomerCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => {
        const counterparty = row.original.invoice?.counterparty;

        if (!counterparty) {
            return (
                <ViewTableCell>
                    <div className={styles.vendorContent}>
                        <span className={styles.noVendor}>-</span>
                    </div>
                </ViewTableCell>
            );
        }

        const tooltipFields: CustomerTooltipField[] = [
            { label: "Customer", value: counterparty.name },
        ];
        if (counterparty.email) {
            tooltipFields.push({ label: "Email", value: counterparty.email });
        }

        return (
            <ViewTableCell>
                <div className={styles.vendorContent}>
                    <Tooltip
                        content={
                            <CustomerTooltipContent fields={tooltipFields} />
                        }
                        side="bottom"
                    >
                        <span className={styles.vendorName}>
                            {counterparty.name}
                        </span>
                    </Tooltip>
                </div>
            </ViewTableCell>
        );
    },
);
